var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5359 21.4345V21.4336H20.541V13.7319C20.541 9.96414 19.753 7.06177 15.4737 7.06177C13.4165 7.06177 12.036 8.22377 11.4724 9.32539H11.4129V7.41352H7.35547V21.4336H11.5803V14.4914C11.5803 12.6635 11.917 10.896 14.1161 10.896C16.283 10.896 16.3153 12.982 16.3153 14.6086V21.4345H20.5359Z",
    fill: "#FF1C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.476562 7.41431H4.70654V21.4344H0.476562V7.41431Z",
    fill: "#FF1C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58956 0.43457C1.2371 0.43457 0.139648 1.5642 0.139648 2.95632C0.139648 4.34845 1.2371 5.5017 2.58956 5.5017C3.94203 5.5017 5.03948 4.34845 5.03948 2.95632C5.03863 1.5642 3.94118 0.43457 2.58956 0.43457V0.43457Z",
    fill: "#FF1C26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4018,
    height: 21,
    fill: "white",
    transform: "translate(0.139648 0.43457)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5137d7392d4494118e0772a7d5884905.svg";
export { ForwardRef as ReactComponent };